export default "/images/da3e1c75c955d439a4f6a442ea39f3d6.avif";